import MerchantUtil from "@/util/MerchantUtil";

/**
 * The sales channels a category or product is offered on (availableForChannelIds) — the one list the product and
 * category forms («Tilgjengelig på følgende kanaler») and the /products filter and channel pills read, so their words
 * cannot drift. `name` is that wording, `where` completes «tilgjengelige …».
 */
const CHANNELS = [
  { id: 'WEB_TAKEAWAY', name: 'Takeaway på Web(nettsiden)', where: 'på nettsiden' },
  { id: 'WEB_DINE_IN', name: 'QR-bestilling ved bord', where: 'med QR-bestilling ved bord' },
  { id: 'KIOSK', name: 'Selvbetjeningskiosk', where: 'i selvbetjeningskiosken' },
  { id: 'POS', name: 'Kasse', where: 'i kassen' }
];

const ALL_IDS = CHANNELS.map(channel => channel.id);

export default {
  CHANNELS,

  /** Whether this merchant chooses channels at all — the edit forms' rule for «Tilgjengelig på følgende kanaler». */
  merchantUsesChannels(){
    const functionality = MerchantUtil.useFunctionality();
    return functionality === 'POS' || functionality === 'KIOSK_TAKEAWAY' || functionality === 'ALL'
        || MerchantUtil.websiteShowDineInMenu();
  },

  /**
   * The channels a product is offered on: its own, within its category's — the edit form only offers the category's.
   * A product without the field predates it and counts as every channel, as the edit form fills it in; so does a
   * category without it. An empty list is no channel. In CHANNELS order.
   */
  channelIdsOf(item, categoryChannelIds){
    const own = Array.isArray(item.availableForChannelIds) ? item.availableForChannelIds : ALL_IDS;
    const allowed = Array.isArray(categoryChannelIds) ? categoryChannelIds : ALL_IDS;
    return ALL_IDS.filter(id => own.includes(id) && allowed.includes(id));
  },

  channelsOf(ids){
    return CHANNELS.filter(channel => ids.includes(channel.id));
  },

  isEveryChannel(ids){
    return ALL_IDS.every(id => ids.includes(id));
  },

  channel(id){
    return CHANNELS.find(channel => channel.id === id) || null;
  }
};
